import TextMobile from "../TextMobile";
import { ReactComponent as EyeOpen } from "../../assets/images/svg/eyeopen.svg";
import { ReactComponent as Eyeclose } from "../../assets/images/svg/eyeclose.svg";

const TextInput = ({
  label,
  value,
  name,
  onChange,
  onKeyDown,
  type,
  error,
  errorMsg,
  styleProp,
  className,
  isEyeOpen,
  setIsEyeOpen,
  pointerEvent,
  elementId,
}) => {
  const handleEye = () => {
    setIsEyeOpen((prevState) => !prevState);
  };

  return (
    <div
      className={className ? `${className} cred-ip` : "cred-ip"}
      style={styleProp}
    >
      <label htmlFor={elementId}>
        <span className="label_1">Enter Your</span>
        <span className="label_2">{label}</span>
      </label>
      {label === "Password" && (
        <button className="passowrd_eye" onClick={handleEye}>
          {isEyeOpen ? <EyeOpen /> : <Eyeclose />}
        </button>
      )}
      <div>
        {type === "phone" ? (
          <TextMobile
            id={elementId}
            value={value}
            name={name}
            type="tel"
            onChange={onChange}
            onKeyDown={onKeyDown}
          />
        ) : (
          <input
            id={elementId}
            style={{ pointerEvents: !pointerEvent ? "" : "none" }}
            className="ip_pass"
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoComplete="false"
            //  aria-label={elementId}
          />
        )}
      </div>

      <div aria-live="assertive" className="error_div1">
        {error && errorMsg}
      </div>
    </div>
  );
};

export default TextInput;
